import React, { useState, useEffect } from "react";
import { NAV_LINKS } from "../../data";
import { BtnOrange } from "../ui/Buttons";

const Navbar = ({ currentPage, navigate }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    navigate(id);
    setMenuOpen(false);
  };

  return (
    <>
      {/* ── Desktop / Tablet bar ── */}
      <nav
        className={`
          fixed top-0 left-0 right-0 z-50
          border-b border-white/8 backdrop-blur-md
          transition-all duration-300
          ${scrolled
            ? "bg-slate-950/98 shadow-[0_4px_30px_rgba(0,0,0,.45)]"
            : "bg-slate-950/94"}
        `}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16">

          {/* Logo */}
          <button
            onClick={() => go("home")}
            className="flex items-center gap-2.5 cursor-pointer bg-transparent border-none shrink-0"
          >
            <span className="w-9 h-9 rounded-xl  flex items-center justify-center shadow-[0_4px_12px_rgba(30,86,217,.4)] overflow-hidden">
              <img
                src="/EminentLogo.png"
                alt="Eminent Solutions Logo"
                className="w-6 h-6 object-contain"
              />
            </span>

            <span className="font-head font-bold text-lg text-white tracking-tight">
              Eminent{" "}
              <span className="text-blue-400">Solutions</span>
            </span>
          </button>

          {/* Desktop links */}
          <div className="hidden lg:flex items-center gap-1">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                className={`
                  font-head text-sm font-medium px-4 py-2 rounded-lg
                  cursor-pointer border-none transition-all duration-150
                  ${currentPage === l.id
                    ? "text-white bg-white/10"
                    : "text-white/70 bg-transparent hover:text-white hover:bg-white/8"}
                `}
              >
                {l.label}
              </button>
            ))}
          </div>

          {/* Desktop actions */}
          <div className="hidden lg:flex items-center gap-3">
            <button
              onClick={() => go("contact")}
              className="font-head font-semibold text-sm text-white border-2 border-white/30 px-4 py-2 rounded-lg bg-transparent cursor-pointer hover:border-white/60 transition-all"
            >
              Client Login
            </button>
            <BtnOrange small onClick={() => go("demo")}>
              Get a Demo
            </BtnOrange>
          </div>

          {/* Hamburger */}
          <button
            className="lg:hidden flex flex-col gap-1.5 p-1.5 bg-transparent border-none cursor-pointer"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            <span className={`block w-6 h-0.5 bg-white rounded transition-all duration-300 ${menuOpen ? "rotate-45 translate-y-2" : ""}`} />
            <span className={`block w-6 h-0.5 bg-white rounded transition-all duration-300 ${menuOpen ? "opacity-0" : ""}`} />
            <span className={`block w-6 h-0.5 bg-white rounded transition-all duration-300 ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`} />
          </button>
        </div>
      </nav>

      {/* ── Mobile menu ── */}
      {menuOpen && (
        <div className="fixed top-16 left-0 right-0 z-40 bg-slate-950 border-b border-white/10 px-6 pb-6 pt-3">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              className={`
                block w-full text-left font-head font-medium text-base
                py-3 border-b border-white/6 cursor-pointer
                bg-transparent border-l-0 border-r-0 border-t-0
                transition-colors
                ${currentPage === l.id ? "text-white" : "text-white/65 hover:text-white"}
              `}
            >
              {l.label}
            </button>
          ))}
          <div className="flex gap-3 mt-5">
            <button
              onClick={() => go("contact")}
              className="flex-1 font-head font-semibold text-sm text-white border-2 border-white/30 py-2.5 rounded-xl bg-transparent cursor-pointer text-center"
            >
              Client Login
            </button>
            <BtnOrange small onClick={() => go("demo")} className="flex-1 justify-center">
              Get a Demo
            </BtnOrange>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
